import { ENDPOINTS, METHODS } from "@/constants/apiConstants";
import { apiSlice } from "../baseApi";

const inventoryBaseEndpoint = ENDPOINTS.INVENTORY;

// Package Type API
export const inventoryApi = apiSlice
  .enhanceEndpoints({
    addTagTypes: ["inventory"],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getInventoryControl: builder.query({
        query: ({ page = 1, per_page = 10, search = "" } = {}) => ({
          url: `${inventoryBaseEndpoint}`,
          params: {
            page,
            per_page,
            ...(search && { search }),
          },
        }),
        // transformResponse: (response) => response.data,
        providesTags: () => [{ type: "inventory" }],
      }),

      addInventoryControl: builder.mutation({
        query: (requestData) => ({
          url: `${inventoryBaseEndpoint}`,
          method: METHODS.POST,
          body: requestData,
        }),
        invalidatesTags: () => [{ type: "inventory" }],
      }),
      updateInventoryControl: builder.mutation({
        query: ({ id, requestData }) => ({
          url: `${inventoryBaseEndpoint}/${id}`,
          method: METHODS.PUT,
          body: requestData,
        }),
        invalidatesTags: () => [{ type: "inventory" }],
      }),
    }),
  });

// Export hooks for usage in components

export const {
    useGetInventoryControlQuery,
    useAddInventoryControlMutation,
    useUpdateInventoryControlMutation,
} = inventoryApi;
